'use client';
import React from 'react';
import type { AssetProps } from '@repo/ui/src/types/image';
import buildImageSrc from '@repo/ui/src/functions/image-functions-aspect-ratio';

export interface Feature {
  image: AssetProps;
  label: string;
}

interface FeatureItemProps {
  image: AssetProps;
  label: string;
}

const FeatureItem = ({ image, label }: FeatureItemProps) => {
  return (
    <div className="flex gap-2 items-end">
      <div className="w-6 h-6 flex-shrink-0">
        <img
          src={buildImageSrc(image)}
          alt={image.accessibilityLabel}
          className="w-full h-full object-contain"
        />
      </div>
      <p className="text-sm text-neutral-600 leading-5">{label}</p>
    </div>
  );
};

interface FeaturesContainerProps {
  features?: Array<Feature>;
}

const FeaturesContainer = ({ features }: FeaturesContainerProps) => {
  if (!features?.length) return null;

  return (
    <div className="grid grid-cols-2 gap-5">
      {features.map((feature, index) => (
        <FeatureItem key={index} image={feature.image} label={feature.label} />
      ))}
    </div>
  );
};

export default FeaturesContainer;
